import { IconType } from "react-icons/lib";
import { TbStethoscope } from "react-icons/tb";

import { HOTEL_CLINIC_NAME_LABELS, HotelClinicNames } from "@/models/hotel-clinic.model";

export type ClinicDestinationOption = {
    value: HotelClinicNames;
    label: string;
    logo?: string;
    Icon?: IconType;
    iconClassName?: string;
};

export const CLINIC_DESTINATION_OPTIONS: ClinicDestinationOption[] = [
    {
        value: HotelClinicNames.ELIT_HAIR,
        label: HOTEL_CLINIC_NAME_LABELS[HotelClinicNames.ELIT_HAIR],
        logo: "/assets/hotel-logos/elitklinik.webp",
    },
    {
        value: HotelClinicNames.RHINO_MEDICAL,
        label: HOTEL_CLINIC_NAME_LABELS[HotelClinicNames.RHINO_MEDICAL],
        logo: "/assets/hotel-logos/rhinomedica-logo-primary-on-white.png",
    },
    {
        value: HotelClinicNames.YES_SMILE,
        label: HOTEL_CLINIC_NAME_LABELS[HotelClinicNames.YES_SMILE],
        logo: "/assets/hotel-logos/yes-smile-logo.png",
    },
];

export const DEFAULT_CLINIC_DESTINATION_ICON = TbStethoscope;
